import type { FC } from "react";

import {
  DRAWER_FOOTER_CLASS,
  type TDrawerFooterProps,
} from "@/ui/components/overlay/Drawer/Drawer.config";
import { Button } from "@/ui/components/primitives";
import { cn } from "@/ui/lib/utils";

export const DrawerFooter: FC<TDrawerFooterProps> = ({ className, ctas, ...props }) => {
  if (!ctas) { return null; }

  return (
    <div
      data-component="DrawerFooter"
      className={cn(DRAWER_FOOTER_CLASS, className)}
      {...props}
    >
      { ctas.primary ? <Button {...ctas.primary} width="fill" /> : null }
      { ctas.secondary ? (
        <Button {...ctas.secondary} variant="tertiary" width="fill" />
      ) : null }
    </div>
  );
};

DrawerFooter.displayName = "DrawerFooter";
